import { UploadFileInfo } from "../store/types";
import { tryParse } from "../utils/object";

// 注意！File对象是不能储存到localstorage中的，改用内存存储
export const errorFileLocalStore = {
  key: "error-file",
  value: "",
  isBrowser: typeof window !== "undefined",
  fileData: {} as Record<string, UploadFileInfo>,

  get(fileId?: string) {
    if (!this.isBrowser) return null;
    try {
      if (fileId) {
        return this.fileData[fileId];
      }
      return this.fileData;
    } catch (e) {
      return null;
    }
  },

  set(fileId: string, value: UploadFileInfo) {
    if (!this.isBrowser) return;
    this.fileData[fileId] = value;
  },

  remove(fileId?: string) {
    // 新增：移除存储项
    if (!this.isBrowser) return;
    if (fileId) {
      delete this.fileData[fileId];
    } else {
      this.fileData = {};
    }
  },
};
